// =============================================================================
// eodStockSnapshot.js — freeze the OPEN stock requests into the EXACT shape Apps
// Script stores in column 12 of the Daily Reports sheet (OpenStockRequestsSnapshot).
// Lane BE, Wave 3 — decommission reader #6.
//
// WHY. `handleDailyReport` (ManchesterReportWriter.js) stores `data.
// openStockRequestsSnapshot` verbatim as column 12 and reads NOTHING from the Sheet
// itself — so today, because the kiosk never sends the field, column 12 is BLANK on
// every EOD row. Once the Sheet stock write is dropped there is no Sheet tab to fall
// back to at all. The fix is where the snapshot is BUILT: the till already reads
// Supabase (stockReader.fetchStockRequests), so it can freeze the snapshot itself.
//
// THE SHAPE, pinned to the READER (ManchesterForecastEngine.js:4403 — "Snapshot is a
// JSON array of {item, time, requestedBy, custom, flag}"): a JSON array, in feed
// order, of the OPEN rows only. `flag` is the sticky running_low/out_of_stock or null.
//
// null vs []: a FAILED read returns null (the caller omits the field, column 12 stays
// blank), NEVER []. An empty array means "no open needs" — a failed read must never
// claim that. This module is the pure mapper; the network read + the Supabase-source
// check live in the caller (foh.jsx). Unit-tested against a captured Sheet example.
// =============================================================================

// A generous cap so one runaway day can't bloat the EOD row's column 12. A shop's
// running list is normally well under 50 open items; 200 is head-room, not a limit
// anyone hits. If it ever truncates, the newest-first feed order keeps the most
// recent needs; the count is what matters for the admin drill-down, not the tail.
export const EOD_SNAPSHOT_CAP = 200;

// requests: the `requests` array from stockReader.fetchStockRequests (walkStock shape).
// Returns the column-12 array [{item, time, requestedBy, custom, flag}] of OPEN rows,
// or null if `requests` is not an array (a failed read — the caller omits the field).
export function openStockSnapshotFromFeed(requests, { cap = EOD_SNAPSHOT_CAP } = {}) {
  if (!Array.isArray(requests)) return null;   // failed read -> null, never [] ("no open needs")
  const open = requests.filter((r) => r && r.closed === false);
  return open.slice(0, cap).map((r) => ({
    item: r.item || "",
    time: r.time || r.requestedTime || "",
    requestedBy: r.requestedBy || r.staffName || "",
    custom: !!r.custom,
    flag: r.flag != null ? r.flag : null,
  }));
}
